/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Box from "@mui/material/Box";
//file
// import sliderRigh from '../../Image/sliderRigh.png'
import GCStockTransfer from "../../Component/Common/ReuseableComponent/GCStockTransfer";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  fAlertToast,
  GetGitterColumns,
  GetCheck_Monthend_DueDate,
  Get_ToggleDropDown_binsearch_Load,
  GetAccountPostingDetail,
  GetLinkDocument,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";
import { inv05_SalesOrder_SOPDetailStockValidation_GETROW } from "../../Server/ApiV2";
import { fKeyTabInput, fcovertToNumber } from "../../Utility/Utilitys";
import { StockAdjustment } from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import WmsFooter from "./processComponent/WmsFooter";
import {
  Set_WmsStockAdjustment_HeadObject_Set,
  Set_WmsStockAdjustment_HeadObject_Init,
} from "./SliceWmsStockAdjustment";
import "./StockAdjustment.css";
import { Wms_StockAdjustment_HeadObject_New_Set } from "./SliceWmsStockAdjustment";
import { Set_StockAdjustment_HeadObject_A_DocStat } from "./SliceWmsStockAdjustment";
import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  fRightClick,
  fLeftClick,
  GetSalesHistory,
  //grid history end
  sTrnTyp,
  sStatusArr,
  fKeyStockAdjustment,
  GetCurrentStock,
  GetUnitArr,
  GetUnitRateArr,
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  fGetValidationDetail_Server,
  GetItemAttributes_Server,

  //Approve
  GetValidateHead_Server,

  //customer
  xGC_Toggle_Head_BinName_DropDown_Arr,
  //narration
  GetAttributes,
  getTransItemStockUOM,
  Unit_Onchange_001,
} from "./StockAdjustmentAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { fCheck_Doc_Rights_001 } from "./../../Utility/Utilitys";
import { FShortCutKey } from "./../../Utility/Utilitys";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function WmsStockAdjustment() {
  const dispatch = useDispatch();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceWmsStockAdjustment.value.HeadObject
  );

  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
   const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value

  const sRoundingVal = 4;
  const sEnterKeyObj = {
    key: "Enter",
  };

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });

  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [sLoading, setLoading] = useState(false);
  //grid saleshistory
  const [sToggleGrid, setToggleGrid] = useState(false);
  const [sGridSalesHistoryRowData, setGridSalesHistoryRowData] = useState([]);
  //grid saleshistory

  //HEAD
  const [sDocLoading, setDocLoading] = useState([]);
  const [sReason, setReason] = useState([]);
  const [sFooterObj, setFooterObj] = useState({
    F_NetValue: 0,
  });

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [sCurrentStock, setCurrentStock] = useState({
    A_CurrentStockQty: 0,
    A_CurrentStockValue: 0,
  });
  const sAdjType = [
    { Uid: "Adj (+)", Name: "Adj (+)" },
    { Uid: "Adj (-)", Name: "Adj (-)" },
    { Uid: "Val (+)", Name: "Val (+)" },
    { Uid: "Val (-)", Name: "Val (-)" },
  ];
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select
  const [isSaveLoaded, setSaveLoaded] = useState(false);

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_AdjType: sAdjType[0].Uid,
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Batch: "",
    B_MDF: new Date(),
    B_EXD: new Date(),
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal

    B_UnitCost: (0).toFixed(sRoundingVal), //Decimal
    B_Value: (0).toFixed(sRoundingVal), //Decimal
    SuppRefNo1: "",
  };

  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_AdjType: sAdjType[0].Uid,
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Batch: "",
    B_MDF: new Date(),
    B_EXD: new Date(),
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_UnitCost: (0).toFixed(sRoundingVal), //Decimal
    B_Value: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: 0,
    SuppRefNo1: "",
  });

  const [sAdjTypeDependency, setAdjTypeDependency] = useState({
    B_CardId: false,
    B_ItmName: false,
    B_Batch: false,
    B_MDF: false,
    B_EXD: false,
    B_BinName: false,
    B_Qty: false,
    B_UnitCost: false,
  });

  //Modal

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_WmsStockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsStockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsStockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event.$d,
        })
      );
    }
  };

  const fLocation = async (e) => {
    dispatch(
      Set_WmsStockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: e.target.value,
      })
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BinName: "",
      B_BinCode: "",
    }));
  };

  const fReason = async (e) => {
    dispatch(
      Set_WmsStockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_Reason: e.target.value,
      })
    );
  };

  //FOOTER FUNCTION

  const fHeadNarration = (e) => {
    dispatch(
      Set_WmsStockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_Narr: e.target.value,
      })
    );
  };

  //DETAIL  FUNCTION
  const fFocusShowSalesHistoryGrid = async () => {
    let vSalesHistoryArr = await GetSalesHistory(
      sBufferObj.B_Itmcd,
      setGridSalesHistoryRowData
    );
    if (vSalesHistoryArr.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
    setToggleGrid(false);
  };

  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));

    await Unit_Onchange_001(
      vUnitvalue?.Unit,
      vUnitvalue,
      sBufferObj.B_Itmcd,
      setBufferObj
    );
  };

  const fUnitCost = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_UnitCost: e.target.value,
    }));
  };

  useEffect(() => {
    if (
      sBufferObj.B_AdjType === "Val (+)" ||
      sBufferObj.B_AdjType === "Val (-)"
    ) {
      let vBValue = fcovertToNumber(sBufferObj.B_UnitCost);
      setBufferObj((obj) => ({
        ...obj,
        B_Value: vBValue.toFixed(sRoundingVal),
      }));
    } else {
      let vBValue =
        fcovertToNumber(sBufferObj.B_Qty) *
        fcovertToNumber(sBufferObj.B_UnitCost);
      setBufferObj((obj) => ({
        ...obj,
        B_Value: vBValue.toFixed(sRoundingVal),
      }));
    }
  }, [sBufferObj.B_Qty, sBufferObj.B_UnitCost, sBufferObj.B_AdjType]);

  const fUnitCostSave_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER" &&
        !isSaveLoaded
      ) {
        setSaveLoaded(true);
        document.getElementsByName("B_URateFc")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const fCardID_ADJType = (xCardID, xAdjtyp = sBufferObj.B_AdjType) => {
    if (xAdjtyp == "Adj (+)" && Number(xCardID) == 0) {
      setAdjTypeDependency((obj) => ({
        ...obj,
        B_ItmName: false,
        B_Batch: false,
        B_MDF: false,
        B_EXD: false,
        B_BinName: false,
        B_Qty: false,
        B_UnitCost: false,
      }));
      setBufferObj((obj) => ({
        ...obj,
        B_UnitCost: 0,
        B_Itmcd: "",
        B_ItmName: "",
        B_Batch: "",
        B_MDF: new Date(),
        B_EXD: new Date(),
        B_BinName: "",
        B_Qty: "",
        B_BinCode: "",
      }));
    } else if (xAdjtyp == "Adj (+)" && xCardID > 0) {
      setAdjTypeDependency((obj) => ({
        ...obj,
        B_ItmName: true,
        B_Batch: true,
        B_MDF: true,
        B_EXD: true,
        B_BinName: false,
        B_Qty: false,
        B_UnitCost: false,
      }));
    }
  };

  const fCardId = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_CardId: e.target.value,
    }));
    if (Number(e.target.value) <= 0) {
      fCardID_ADJType(e.target.value);
    }
  };
  const fCardId_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Unit: "",
      B_Batch: "",
      B_UnitCost: "",
      B_Value: "",
      B_MDF: new Date(),
      B_EXD: new Date(),
    }));
    setUnit([]);
  };
  const fCardIdEnter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      if (sBufferObj.CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      } else if (sBufferObj.B_BinCode !== "" && sBufferObj.B_BinName !== "") {
        const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
          sBufferObj.B_BinName,
          "Any",
          "Y",
          vRdxWmsHead.A_Loc
        );

        if (vReasonWmBin.length > 0 && vReasonWmBin[0]?.OpenBin == "Y") {
          GetBarcodeDetail(sBufferObj.B_CardId);
        } else {
          GetCartIDDetail(sBufferObj.B_CardId);
        }
      } else {
        fAlertToast("FAILED", "BinName is empty");
        setTimeout(() => {
          document.getElementsByName("B_BinName")[0]?.focus();
        }, 100);
      }
    } else if (e.key == "Backspace") {
      fCardId_BackSpace_Clear();
    }
  };
  //API NOTIFICATION_PICKINGCARDIDSEARCH_GETROW
  const GetCartIDDetail = async (xCardId, xeditRow = false) => {
    const CartBarcodeDetailObj = {
      CardId: xCardId,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "NOTIFICATION_PICKINGCARDIDSEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: CartBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: CartBarcodeDetail.ResultSet[0].Name2,
          B_CardId: CartBarcodeDetail.ResultSet[0].CardID,
          B_Batch: CartBarcodeDetail.ResultSet[0].BatchNo,
          B_MDF: CartBarcodeDetail.ResultSet[0].BatchDt,
          B_EXD: CartBarcodeDetail.ResultSet[0].ExpDt,
          SuppRefNo1: CartBarcodeDetail?.ResultSet[0]?.SuppRefNo1,
        }));
        fCardID_ADJType(CartBarcodeDetail.ResultSet[0].CardID);
        if (CartBarcodeDetail.ResultSet[0].ItmCd !== "" && xeditRow == false) {
          fUnitAndItemCodeDependenc(
            CartBarcodeDetail.ResultSet[0].ItmCd,
            CartBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
    }
  };
  const GetBarcodeDetail = async (xBarcode, xeditRow = false) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_Loc: vRdxWmsHead.A_Loc,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: vBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: vBarcodeDetail.ResultSet[0].Name2,
          B_CardId: vBarcodeDetail.ResultSet[0].CardID,
          B_Batch: vBarcodeDetail.ResultSet[0].BatchNo,
          B_MDF: vBarcodeDetail.ResultSet[0].BatchDt,
          B_EXD: vBarcodeDetail.ResultSet[0].ExpDt,
          SuppRefNo1: vBarcodeDetail?.ResultSet[0]?.SuppRefNo1,
        }));
        fCardID_ADJType(vBarcodeDetail.ResultSet[0].CardID);
        if (vBarcodeDetail.ResultSet[0].ItmCd !== "" && xeditRow == false) {
          fUnitAndItemCodeDependenc(
            vBarcodeDetail.ResultSet[0].ItmCd,
            vBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong barcode Id");
      }
    } else {
      fAlertToast("FAILED", vBarcodeDetail.response.data.message);
    }
  };

  const fUnitAndItemCodeDependenc = async (xItemCode, xUnit) => {
    let xUnitArr = await GetUnitArr(xItemCode, setUnit);
    if (xUnitArr.length > 0) {
      var vUnit = xUnitArr.find((obj) => {
        return obj.Unit == xUnit;
      });
      let currentUnitID = 0;
      if (!!vUnit) {
        currentUnitID = vUnit.Unit;
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vUnit.Unit,
          B_PackQty: vUnit.PackQty,
        }));
      } else {
        currentUnitID = xUnitArr[0].Unit;
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: xUnitArr[0].Unit,
          B_PackQty: xUnitArr[0].PackQty,
        }));
        fAlertToast("FAILED", "UnitID and Card UnitID Not Matched");
      }
      let currentUnitRateArr = await GetUnitRateArr(
        xItemCode,
        currentUnitID,
        vRdxWmsHead?.A_Loc,
        "" // vRdxWmsHead?.A_RefDocTyp,
      );

      if (currentUnitRateArr.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_UnitCost: currentUnitRateArr[0].CostPr,
          B_Value: currentUnitRateArr[0].LPRate,
        }));
      }
      setTimeout(() => {
        document.getElementsByName("B_Qty")[0]?.focus();
      }, 500);
    }
  };

  const fBatch = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Batch: e.target.value,
    }));
  };
  const fMDF = (e) => {
    if (e?.$d == "Invalid Date" || e?.$d == null || e?.$d === undefined) {
      setBufferObj((obj) => ({
        ...obj,
        B_MDF: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        B_MDF: e.$d,
      }));
    }
  };
  const fEXD = (e) => {
    if (e?.$d == "Invalid Date" || e?.$d == null || e?.$d === undefined) {
      setBufferObj((obj) => ({
        ...obj,
        B_EXD: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        B_EXD: e.$d,
      }));
    }
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };

  const fAdjType = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_AdjType: e.target.value,
    }));
    fAdjTypeDependency(e.target.value);
  };

  const fAdjTypeDependency = (xAdjType) => {
    if (xAdjType == "Adj (+)") {
      setAdjTypeDependency((obj) => ({
        ...obj,
        B_CardId: false,
        B_ItmName: false,
        B_Batch: false,
        B_MDF: false,
        B_EXD: false,
        B_BinName: false,
        B_Qty: false,
        B_UnitCost: false,
      }));
      setBufferObj((obj) => ({
        ...obj,
        B_UnitCost: 0,
        B_CardId: "",
        B_Itmcd: "",
        B_ItmName: "",
        B_Batch: "",
        B_MDF: new Date(),
        B_EXD: new Date(),
        B_BinName: "",
        B_Qty: "",
        B_BinCode: "",
      }));
    } else if (xAdjType == "Adj (-)") {
      setAdjTypeDependency((obj) => ({
        ...obj,
        B_CardId: false,
        B_ItmName: true,
        B_Batch: true,
        B_MDF: true,
        B_EXD: true,
        B_BinName: false,
        B_Qty: false,
        B_UnitCost: true,
      }));
      setBufferObj((obj) => ({
        ...obj,
        B_UnitCost: 0,
        B_CardId: "",
        B_Itmcd: "",
        B_ItmName: "",
        B_Batch: "",
        B_MDF: new Date("01/01/1990"),
        B_EXD: new Date("01/01/1990"),
        B_BinName: "",
        B_Qty: "",
        B_BinCode: "",
      }));
    } else if (xAdjType == "Val (+)") {
      setAdjTypeDependency((obj) => ({
        ...obj,
        B_CardId: true,
        B_ItmName: false,
        B_Batch: true,
        B_MDF: true,
        B_EXD: true,
        B_BinName: true,
        B_Qty: true,
        B_UnitCost: false,
      }));
      setBufferObj((obj) => ({
        ...obj,
        B_Qty: 0,
        B_CardId: 0,
        B_Itmcd: "",
        B_ItmName: "",
        B_Batch: "",
        B_MDF: new Date("01/01/1990"),
        B_EXD: new Date("01/01/1990"),
        B_BinName: "",
        B_UnitCost: 0,
        B_BinCode: "",
      }));
    } else {
      setAdjTypeDependency((obj) => ({
        ...obj,
        B_CardId: true,
        B_ItmName: false,
        B_Batch: true,
        B_MDF: true,
        B_EXD: true,
        B_BinName: true,
        B_Qty: true,
        B_UnitCost: false,
      }));
      setBufferObj((obj) => ({
        ...obj,
        B_Qty: 0,
        B_CardId: 0,
        B_Itmcd: "",
        B_ItmName: "",
        B_Batch: "",
        B_MDF: new Date("01/01/1990"),
        B_EXD: new Date("01/01/1990"),
        B_BinName: "",
        B_UnitCost: 0,
        B_BinCode: "",
      }));
    }
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    setLoading(true);

    

    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(
          vItemSearchFull,
          vRdxWmsHead,
          sBufferObj,
          setBufferObj,
          setUnit
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        SuppRefNo1: "",
      }));
      setUnit([]);
    }
  };

  //MODAL HEAD

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_Loc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(
        vItemSearchFull,
        vRdxWmsHead,
        sBufferObj,
        setBufferObj,
        setUnit
      );
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //GCCustomer Search

  const xfGC_Toggle_Head_BinName_Name = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinName: e.target.value,
      B_CardId: "",
    }));
    // fCardId_BackSpace_Clear();
  };

  const [
    sGC_Toggle_Head_BinName_SearchDropdownObj,
    setGC_Toggle_Head_BinName_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [sGC_Toggle_Head_BinName_GridData, setGC_Toggle_Head_BinName_GridData] =
    useState([]);
  const [
    sGC_Toggle_Head_BinName_ToggleDropDowm,
    setGC_Toggle_Head_BinName_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_BinName_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setItemToggleDropdown(false);
      setGC_Toggle_Head_BinName_GridData([]);
      setGC_Toggle_Head_BinName_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_BinName_ToggleDropDowm(true);
      setItemToggleDropdown(false);
    }
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_BinName_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_BinName,
      }));
      if (sBufferObj.B_BinName != "") {
        const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
          sBufferObj.B_BinName,
          "Any",
          "N",
          vRdxWmsHead.A_Loc
        );

        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_BinName_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_BinName_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_BinName_Toggle();
    }
  };

  //1stcall
  const fGC_Toggle_Head_BinName_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sBufferObj.B_BinName,
        "Any",
        "Y",
        vRdxWmsHead.A_Loc
      );

      if (vExactSearch.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_BinCode: vExactSearch[0].UId,
          B_BinName: vExactSearch[0].Name1,
        }));

        setTimeout(() => {
          fKeyTabInput(e, "B_Batch");
        }, 500);
      } else {
        fGC_Toggle_Head_BinName_Dropdown_SearchModalKey(e);
      }

      if (sBufferObj.B_BinCode != "") {
        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      }
    }
    if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_BinCode: "",
        B_CardId: "",
      }));
      // fCardId_BackSpace_Clear();
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_BinName_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sGC_Toggle_Head_BinName_SearchDropdownObj.Data,
        sGC_Toggle_Head_BinName_SearchDropdownObj.Type,
        "N",
        vRdxWmsHead.A_Loc
      );

      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_BinName_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_BinName_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_BinName_OnRowClick = async (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinCode: e?.row?.UId,
      B_BinName: e?.row?.Name1,
    }));
    xfGC_Toggle_Head_BinName_Toggle();
    setTimeout(() => {
      document?.getElementsByName("B_Batch")[0]?.focus();
    }, 500);
  };

  const fGC_Toggle_Head_BinName_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_BinName_OnRowClick(newSelectionModel);
    }
  };

  //GC CustomerSearch End

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //MODAL SEARCH
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: new Date(),
    Loc: vRdxDBLocation[0]?.UID ? vRdxDBLocation[0]?.UID : "",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    document.getElementById("IdSearch")?.blur();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vRdxDBLocation[0]?.UID,
    }));
    GetSearchValue("", "APICallLocModal", vRdxDBLocation[0]?.UID);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: new Date(),
      Loc: vRdxDBLocation[0]?.UID,
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail);
    fCloseSearchModal();
  };

  //GCSearch
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
      fDisplay(
        newSelectionModel?.row?.A_VocTyp,
        newSelectionModel?.row?.A_VocNo,
        dispatch,
        fNewDetail
      );
      fCloseSearchModal();
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: moment(event.target.value, "YYYY-MM-DD")._d,
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // GetSearchValue("", "APICALLDATE", changedDate);

    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UID == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UID,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UID);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let vSearchObj = {
        // VocDt:
        //   xAPICALL === "APICALLDATE"
        //     ? moment(xSTATUS).format("MM/DD/YYYY")
        //     : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY"),

        TrnTyp: sTrnTyp,
        VocNo: sSearchModalObj.VocNo,
        PostDt: "01/01/1900",
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        Status: xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await fExecuteAPI("WMINV11_search_GETROW", FinalObj);
      if (vSearch?.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      } else {
        fAlertToast("FAILED", vSearch?.response?.data?.Status);
      }
    }
  };

  //MODAL SEARCH END

  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = StockAdjustment();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = StockAdjustment();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //document
  const [sDocumentModal, setDocumentModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const fDocument = () => {
    fOpenDocumentModal();
  };
  const fOpenDocumentModal = () => {
    setDocumentModal(true);
  };
  const fCloseDocumentModal = (e) => {
    setDocumentModal(false);
  };

  //GCLandedCost

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vTransAuditObj);
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", FinalObj);
    if (vTransAudit?.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };

  //API DETAIL

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].A_VocTyp,
      sUser_Doc_Arr[0].A_VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
       
      //  http://94.200.177.214:3010/WMS/StockAdjustment?prntyp=WMINV11&voctyp=WA001&vocno=WAJ0004823&trntyp=WMINV11
      let urlPrint =
        vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val +
        "WMS/StockAdjustment?prnTyp=" +
        xPrnTyp +
        "&voctyp=" +
        vRdxWmsHead.A_VocTyp +
        "&vocno=" +
        vRdxWmsHead.A_VocNo +
        "&trntyp=" +
        sTrnTyp;
      setWebReportUrlModal(urlPrint);
      fWebReport();
      console.log(urlPrint);
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );

  const fSave3 = async () => {
    let iValidateHeadApprove = await GetValidateHead_Server(
      dispatch,
      false //xapprove false in save
    );

    if (!iValidateHeadApprove) return;

    let vfGetValidationDetailInfo = await fGetValidationDetail_Server(
      sBufferObj
    );

    if (!vfGetValidationDetailInfo) return;

    // fSaveHead(
    //   true,
    //   setUser_Doc_Arr,
    //   sUser_Doc_Arr,
    //   dispatch,
    //   fNewDetail,
    //   sBufferObj
    // );
    fSave4();
  };

  const fSOPValidation = async () => {
    let vValidationHeadInfoObj = {
      Loc: vRdxWmsHead.A_Loc,
      UserGrp: vRdxuserInfo.UserID,
      TrnTyp: sTrnTyp,
      v_ItmCd: sBufferObj.B_Itmcd,
      v_Unit: sBufferObj.B_Unit,
      v_Qty: sBufferObj.B_Qty,
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_SrNo: sBufferObj.B_Srno,
    };

    let iValidation = await inv05_SalesOrder_SOPDetailStockValidation_GETROW(
      vValidationHeadInfoObj
    );
    if (iValidation?.status === 200) {
      return iValidation?.data?.ResultSet;
    }
  };

  const fSave4 = async () => {
    // if (Number(sBufferObj.B_Qty) < 0) {
    //   let iResp = await fSOPValidation();
    //   if (iResp?.length > 0 && !!iResp[0]?.messgae) {
    //     fAlertToast("FAILED", iResp[0]?.messgae || "Insufficient Stock");
    //     return;
    //   } else if (
    //     iResp?.length > 0 &&
    //     (iResp[0]?.messgae === "" ||
    //       iResp[0]?.messgae === null ||
    //       iResp[0]?.messgae === undefined)
    //   ) {
    //     fSave5();
    //   }
    // } else {
    //   fSave5();
    // }
    fSave5();
  };

  const fSave5 = async () => {
    fSaveHead(
      true,
      setUser_Doc_Arr,
      sUser_Doc_Arr,
      dispatch,
      fNewDetail,
      sBufferObj
    );
  };

  const fSave2 = async () => {
    let iItemAttri = await GetItemAttributes_Server(dispatch, sBufferObj);

    if (iItemAttri.length > 0) {
      if (iItemAttri[0].Linking != "") {
        fAlertToast("FAILED", iItemAttri[0].Linking);
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }

      if (iItemAttri[0]?.ItmActive != "Y") {
        fAlertToast("FAILED", "Select items is in-activated");
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }

      fSave3();
    }
  };
  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      trnTyp: sTrnTyp,
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      A_PostDt: moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY"),
      A_Loc: vRdxWmsHead.A_Loc,
      A_Party: "",
      userCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
      netAmt: sFooterObj.F_NetValue,
      revNarr: "Draft to Enter",
    };
    const vRevereTransaction = await fExecuteAPI(
      "REVERSETRANSACTION_GETROW",
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };
  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      setSaveLoaded(false);
      if (vRdxWmsHead.A_DocStat === "DRAFT") {
        confirmAlert({
          title: "Reverse",
          message: `Are you sure to Reverse.`,
          buttons: [
            {
              className: "alertBtn",
              label: "Yes",
              onClick: async () => {
                let reverseResp = await GetRevereTransaction();
                if (reverseResp.Type == "SUCCESS") {
                  fClearErrorMsg();
                  dispatch(
                    Set_StockAdjustment_HeadObject_A_DocStat({
                      A_DocStat: "ENTER",
                    })
                  );
                  fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
                } else {
                  fAlertToast("FAILED", reverseResp.response.data.Status);
                }
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {},
            },
          ],
        });
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);

        if (!validation) return;

        let validationDetil = fValidationDetail_Client(
          sBufferObj,
          setErrorMsgDetail
        );

        if (!validationDetil) return;
        fSave2();
      }
    }, 800);
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);

      if (!validation) return;
      
      if ( vRdxDBKernObj.MONTH_END_VALDN_INV11?.Val === "Y") {
        let CheckDueDate = await GetCheck_Monthend_DueDate(
          vRdxWmsHead.A_Loc,
          vRdxWmsHead.A_PostDt
        );
        if (!CheckDueDate) return;
      }

      let iValidateHeadApprove = await GetValidateHead_Server(
        dispatch,
        true //xapprove true in approve
      );

      if (!iValidateHeadApprove) return;

      fSaveHead(
        false,
        setUser_Doc_Arr,
        sUser_Doc_Arr,
        dispatch,
        fNewDetail,
        sBufferObj,
        xDocStatus
      );
    }, 800);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      fNewHead();
      fNewDetail(0, sDocLoading[0]?.VocTyp);
      document.getElementsByName("A_RefDt")[0]?.focus();
    } else {
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fNewHead = async () => {
    dispatch(Set_WmsStockAdjustment_HeadObject_Init()); // Head Clearing

    // Setting Initial List Box 0th Object
    dispatch(
      Wms_StockAdjustment_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: vRdxDBLocation[0]?.UID,
        A_Reason: sReason[0].Uid,
      })
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);

    document.getElementsByName("A_PostDt")[0]?.focus();
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = (xVocNo, xVocTyp) => {
    setBufferObj(vBufferObjInit);
    //if inter.comp then tax group should be 0
    fAdjTypeDependency(sAdjType[0].Uid);
    setUnit([]);

    fLoad_Grid(xVocNo, 0, setDetailGridData, xVocTyp, setFooterObj);

    document.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  const fDeleteHead = async () => {
    let vDeleteSIHeadObj = {
      A_TrnTyp: sTrnTyp,
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      IP: vRdxuserInfo.IP,
      UserId: vRdxuserInfo.UserID,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIHeadObj);
    const vDeleteSIHead = await fExecuteAPI(
      "WMINV11_deleteHead_GETROW",
      FinalObj
    );

    if (vDeleteSIHead?.Type?.toUpperCase() === "SUCCESS") {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Set_StockAdjustment_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_VocNo,
          dispatch,
          fNewDetail
        );
        // fNewDetail(
        //   vRdxWmsHead.A_VocNo,
        //   vRdxWmsHead.A_Rounding,
        //   vRdxWmsHead.A_VocTyp,

        // );
        fAlertToast("SUCCESS", "Successfully Deleted");
      }
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIDetailObj = {
      B_VocTyp: vRdxWmsHead.A_VocTyp,
      B_VocNo: vRdxWmsHead.A_VocNo,
      B_Srno: Srno,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await fExecuteAPI(
      "WMINV11_deleteDetail_GETROW",
      FinalObj
    );

    if (vDeleteSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    fAdjTypeDependency(item.row.B_AdjTyp);
    fCardID_ADJType(item.row.B_CardID, item.row.B_AdjTyp);
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_Srno,
      B_AdjType: item.row.B_AdjTyp,
      B_CardId: item.row.B_CardID,
      B_Itmcd: item.row.B_Itmcd,
      B_ItmName: item.row.ItmName,
      B_Batch: item.row.B_BatchNo,
      B_MDF: item.row.B_BatchDt,
      B_EXD: item.row.B_ExpDt,
      B_BinCode: item.row.B_BinCd,
      B_BinName: item.row.BinName,
      B_Qty: item.row.B_Qty,
      B_UnitCost: item.row.B_UCost, //Decimal
      B_Value: item.row.B_NetAmt, //Decimal
      SuppRefNo1: item?.row?.SuppRefNo1 || "", //Decimal
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));
    // fAdjTypeDependency(item.row.B_AdjTyp);
    fCloseViewModal();
  };

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setItemToggleDropdown(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    let iAttributeResp = await GetAttributes(
      setUser_Doc_Arr,
      setObjectRights,
      setDocLoading,
      setReason
    );

    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
    };

    let vDocLoadingArr = iAttributeResp?.DocLoading;

    if (vDocLoadingArr.length > 0) {
      icurrentDocLoading = vDocLoadingArr[0];
    }

    let icurrentReason = {
      Uid: "",
      Name1: "",
    };

    let vReasonArr = iAttributeResp?.Reason;

    if (vReasonArr.length > 0) {
      icurrentReason = vReasonArr[0];
    }

    dispatch(
      Set_WmsStockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,
        A_Loc:
          vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
            ? vRdxDBLocation[0]?.UID
            : vRdxWmsHead.A_Loc,
        A_Reason:
          vRdxWmsHead.A_Reason == "" ||
          vRdxWmsHead.A_Reason === null ||
          vRdxWmsHead.A_Reason === undefined
            ? icurrentReason.Uid
            : vRdxWmsHead.A_Reason,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      setDetailGridData,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp,
      setFooterObj
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, vRdxDBLocation]);
  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
          setGC_Toggle_Head_BinName_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
          setGC_Toggle_Head_BinName_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setToggleGrid(false);
    }
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("WmsStockAdjustmentContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "WMINV11";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  useEffect(() => {
    let iDate = moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY");
    if (
      vRdxWmsHead.A_DocStat === "POST" ||
      vRdxWmsHead.A_PostDt == "" ||
      vRdxWmsHead.A_PostDt == null ||
      vRdxWmsHead.A_PostDt === undefined ||
      vRdxWmsHead.A_PostDt == "Invalid Date" ||
      new Date(iDate) < new Date("01/01/1990")
    ) {
      return;
    } else {
      GetCurrentStock(
        vRdxWmsHead.A_Loc,
        sBufferObj.B_Itmcd,
        vRdxWmsHead.A_PostDt,
        setCurrentStock
      );
    }

    // GetCurrentStock(
    //   vRdxWmsHead.A_Loc,
    //   "8049542",
    //   vRdxWmsHead.A_PostDt,
    //   setCurrentStock
    // );
  }, [
    vRdxWmsHead.A_Loc,
    sBufferObj.B_Itmcd,
    vRdxWmsHead.A_PostDt,
    vRdxWmsHead.A_DocStat,
  ]);
  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty:
        fcovertToNumber(sBufferObj.B_Qty) *
        fcovertToNumber(sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);
  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);
  //customer
  const [
    xGC_Toggle_Head_BinName_GridColumns,
    setxGC_Toggle_Head_BinName_GridColumns,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "UId", headerName: "Code", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);

  const [GridDataSalesHistoryColumns, setGridDataSalesHistoryColumns] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "A_VocNo", headerName: "Inv.N0", width: 130 },
      {
        field: "A_PostDt",
        headerName: "Date",
        width: 130,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Unit", headerName: "Unit", width: 130 },
      { field: "GrossAmt", headerName: "GrossAmt", width: 130 },
      { field: "NetAmt", headerName: "NetAmt", width: 130 },
      { field: "Qty", headerName: "Qty", width: 130 },
    ]);
  //GCSearch
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "PartyName", headerName: "Vendor", width: 250 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "A_NetAmt", headerName: "NetAmt", width: 90 },
    { field: "SalesGroup", headerName: "Sales Group", width: 130 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_VocTyp", headerName: "A_VocTyp", width: 90, hide: true },
  ]);
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ]);

  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "B_Srno", headerName: "Sr.No", width: 50 },
    { field: "B_AdjTyp", headerName: "AdjTyp", width: 60 },
    { field: "B_CardID", headerName: "CardID", width: 150 },
    { field: "B_Itmcd", headerName: "Item Code", width: 100 },
    { field: "ItmName", headerName: "Item Name", width: 300 },
    { field: "B_Qty", headerName: "Qty", width: 100 },
    { field: "B_Unit", headerName: "B_Unit", width: 100, hide: true },
    { field: "UnitName", headerName: "Unit", width: 100 },
    { field: "B_BaseQty", headerName: "BaseQty", width: 150 },
    { field: "B_UCost", headerName: "Unit Cost", width: 100 },
    { field: "B_NetAmt", headerName: "B_NetAmt", width: 90 },
    { field: "B_RSP", headerName: "B_RSP", width: 100, hide: true },
    { field: "B_BatchNo", headerName: "Batch", width: 100 },
    {
      field: "B_BatchDt",
      headerName: "MDF",
      width: 100,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "B_ExpDt",
      headerName: "EXD",
      width: 100,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "BinName", headerName: "BinName", width: 100 },
    { field: "B_BinCd", headerName: "B_BinCd", width: 100, hide: true },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 100, hide: true },
  ]);

  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "STOCK_ADJUSTMENT_DETAIL",
      GridDataColumnsWmsSiDetail
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "STOCK_ADJUSTMENT_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "STOCK_ADJUSTMENT_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setxGC_Toggle_Head_BinName_GridColumns,
      "STOCK_ADJUSTMENT_BIN",
      xGC_Toggle_Head_BinName_GridColumns
    );
    GetGitterColumns(
      setGridDataSalesHistoryColumns,
      "STOCK_ADJUSTMENT_HISTORY",
      GridDataSalesHistoryColumns
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_RefDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={vRdxWmsHead.A_DocStat != "ENTER"}
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          vRdxWmsHead.A_DocStat == "ENTER" || vRdxWmsHead.A_DocStat == "DRAFT"
            ? false
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-outbound-grv">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat != "ENTER" ? true : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat == "ENTER" ||
                        vRdxWmsHead.A_DocStat == "DRAFT"
                          ? false
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="PrintId"
                      onClick={(e) => {
                        fPrint("WMINV11");
                      }}
                    >
                      Stock Adjustment
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="IdAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      sTransItemStockObj={sTransItemStockObj}
                      xTransItemStockShow={
                        vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() == "Y"
                      }
                      //grid saleshistory
                      sToggleGrid={sToggleGrid}
                      sGridSalesHistoryRowData={sGridSalesHistoryRowData}
                      GridDataSalesHistoryColumns={GridDataSalesHistoryColumns}
                      //grid saleshistory end
                      xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                      xErrorMsg={sErrorMsg}
                      vRdxuserLoc={vRdxDBLocation}
                      xKey={fKeyStockAdjustment}
                      vRdxWmsHead={vRdxWmsHead}
                      fonSelectedGrnType={fGrnType}
                      sDocLoadingGrnType={sDocLoading}
                      fGrnDate={fGrnDate}
                      fLocation={fLocation}
                      fReason={fReason}
                      sReason={sReason}
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        sCurrentStock={sCurrentStock}
                        sAdjTypeDependency={sAdjTypeDependency}
                        fFocusShowSalesHistoryGrid={fFocusShowSalesHistoryGrid}
                        xContent_Focus={fContent_Focus}
                        xContent_Blur={fContent_Blur}
                        xErrorMsgDetail={sErrorMsgDetail}
                        vRdxWmsHead={vRdxWmsHead}
                        xBufferObj={sBufferObj}
                        sUnit={sUnit}
                        sAdjType={sAdjType}
                        fUnit={fUnit}
                        fUnitCost={fUnitCost}
                        fUnitCostSave_onKeyUp={fUnitCostSave_onKeyUp}
                        fAdjType={fAdjType}
                        fOpenContentItemSearchModalKey={fItemSearchKey}
                        fQty={fQty}
                        fCardId={fCardId}
                        fCardIdEnter={fCardIdEnter}
                        fBatch={fBatch}
                        fMDF={fMDF}
                        fEXD={fEXD}
                        //GC toggle
                        fItemName={fItemName} //onchange main input
                        xMediaQuery={vMediaQuery} //mobile screen
                        xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                        xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                        xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                        xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                        xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                        xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                        xData={ItemSearchData} // GCToggleSearch-select-tag arr
                        xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                        xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                        xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                        //customer

                        xGC_Toggle_Head_BinName_DropDown_Arr={
                          xGC_Toggle_Head_BinName_DropDown_Arr
                        } //sub input arr
                        xfGC_Toggle_Head_BinName_Name={
                          xfGC_Toggle_Head_BinName_Name
                        } //onchange main input
                        xGC_Toggle_Head_BinName_Toggle={
                          sGC_Toggle_Head_BinName_ToggleDropDowm
                        } //boolean true  false
                        xGC_Toggle_Head_BinName_onKeyUp={
                          fGC_Toggle_Head_BinName_onKeyUp
                        } //main input enter
                        xGC_Toggle_Head_BinName_SearchDropdownObj={
                          sGC_Toggle_Head_BinName_SearchDropdownObj
                        } //sub input obj
                        xGC_Toggle_Head_BinName_Dropdown_onChange={
                          fGC_Toggle_Head_BinName_Dropdown_onChange
                        } //sub input onchange
                        xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load={
                          fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
                        } //sub input load
                        xGC_Toggle_Head_BinName_GridColumns={
                          xGC_Toggle_Head_BinName_GridColumns
                        } //sub input col
                        xGC_Toggle_Head_BinName_GridData={
                          sGC_Toggle_Head_BinName_GridData
                        } //sub input grid
                        xfGC_Toggle_Head_BinName_OnCellKeyDown={
                          fGC_Toggle_Head_BinName_OnCellKeyDown
                        } //sub input row enter
                        xfGC_Toggle_Head_BinName_OnRowClick={
                          fGC_Toggle_Head_BinName_OnRowClick
                        } //sub input row click
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={fDetail_Grid_onRowClick}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div style={{ height: "50vh", width: "100%" }}>
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fDetail_Grid_onRowClick}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <WmsFooter
                      xErrorMsg={sErrorMsg}
                      vRdxWmsHead={vRdxWmsHead}
                      fHeadNarration={fHeadNarration}
                      sFooterObj={sFooterObj}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View "} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsFooter
              xErrorMsg={sErrorMsg}
              vRdxWmsHead={vRdxWmsHead}
              fHeadNarration={fHeadNarration}
              sFooterObj={sFooterObj}
            />
          </div>
        </Box>
      </Modal>
      {/* Search  */}
      <GCStockTransfer
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={vRdxDBLocation}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Stock Adjustment - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
      />
      {/* Audit  */}
      <Box>
        {/* <GCAudit
          xOpen={sAuditModal}
          xTitle={"AUDIT"}
          fCloseAuditModal={fCloseAuditModal}
          sAuditSelectArr={sAuditSelectArr}
          GridDataAuditColumns={GridDataAuditColumns}
          GridDataAuditRows={sGridDataAuditRows}
          xAuditId={xAuditId}
          fonChangeAuditSelect={fonChangeAuditSelect}
          xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        /> */}
        <GCAuditTblCard
          xOpen={sAuditModal}
          xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
          fCloseAuditModal={setAuditModal}
          trnTyp={sTrnTyp}
          vocTyp={vRdxWmsHead.A_VocTyp}
          vocNo={vRdxWmsHead.A_VocNo}
        />
      </Box>
      <Modal
        open={sDocumentModal}
        onClose={fCloseDocumentModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-popup">on progerss document...</Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
